import React from "react";
import { withAppState } from "../../state";
import { withFocusable } from "../../services/visualLibraryService";
import { HeaderStyled, LogoStyled, ImageStyled, MainMenuContainerStyled } from "./styles/Styled";
import { getLogger } from "../../utils/logger";
import { findFromBrands } from "../../helpers/find";
import { getPath } from "../../utils/getPath";
import packageJson from "../../../package.json";
import './margin.css';


const appVersionQueryParameter = `?version=${packageJson?.version}`;

const MainMenuContainerFocus = withFocusable(MainMenuContainerStyled);

let slider;

export const defaultFocusPath = "mainMenu";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: false,
      loaded: false
    };
    this.handleFocusMenu = this.handleFocusMenu.bind(this);
    this.navigate = this.navigate.bind(this);
    this.logger = getLogger();
    this.brandName = null;
    this.imageUrlSubscription = "";
    this.imageUrlBrands = "";
  }

  componentDidUpdate() {
    let isBrand = window.location.pathname.includes("brands/");
    const names = isBrand && window.location.pathname.split("/");
    if (isBrand) {
      this.brandName = names[2];
      let subscription = findFromBrands(this.brandName, this.props.applicationState.subscriptions || []);
      let baseSubscription = findFromBrands(this.brandName, subscription?.brands);
      this.imageUrlSubscription =
        subscription?.displayName === "STARZPLAY"
          ? `${baseSubscription?.configuration.logoDefaultPNG}`
          : `${subscription?.configuration.logoDefaultPNG}${appVersionQueryParameter}`;
    } else {
      this.brandName = null;
    }
  }

  handleFocusMenu(focused) {
    this.setState({ activeMenu: focused });
  }

  navigate() {
    slider.navigate();
  }

  left() {
    slider.left();
  }

  right() {
    slider.right();
  }

  render() {
    return (
      <HeaderStyled className={this.state.activeMenu && "isActiveMenu"}>
        {!this.brandName ? (
          <React.Fragment>


            <img className="margin" src="https://ev-cdn-lb.shoq.com.pk/prd-peg-data/default/web3/resources/images/shoq.svg"   />


            <MainMenuContainerFocus
              focusPath={defaultFocusPath}
              handleFocus={this.handleFocusMenu}
              onRef={ref => (slider = ref)}
              onLeft={this.left}
              onRight={this.right}
              onEnterPress={this.navigate}
            />
          </React.Fragment>
        ) : (
          <ImageStyled
            src={this.imageUrlSubscription}
            alt={this.brandName}
          />
        )}

      </HeaderStyled>
    );
  }
}

Header.defaultFocusPath = defaultFocusPath;

export default withAppState(Header);
